import { ReactNode } from "react";
import { useAppBootstrap } from "./AppBootstrapProvider";
import { useAccountReadiness } from "./AccountReadinessProvider";
import { ProfilePhotoContext } from "./profilePhotoContext";
import { useProfilePhotoSubscription } from "./useProfilePhotoSubscription";

export function ProfilePhotoProvider({ children }: { children: ReactNode }) {
  const { currentUser } = useAppBootstrap();
  const readiness = useAccountReadiness();
  const state = useProfilePhotoSubscription(currentUser?.uid, readiness.status === "complete");
  return <ProfilePhotoContext.Provider value={state}>{children}</ProfilePhotoContext.Provider>;
}
